import React from "react";
import { createOrderRefreshQueue, subscribeOrderDataChange } from "../utils/orderDataSync.js";

export default function useOrderDataSync({ source, enabled = true, refresh, onError }) {
  const latest = React.useRef();
  latest.current = { enabled, refresh, onError };
  const queue = React.useRef(null);
  React.useEffect(() => {
    const current = createOrderRefreshQueue({
      enabled: () => latest.current.enabled && document.visibilityState !== "hidden",
      refresh: () => latest.current.refresh(),
      onError: (error) => latest.current.onError?.(error),
    });
    queue.current = current;
    const unsubscribe = subscribeOrderDataChange((event) => {
      // The saving page already refreshes itself. Other tabs, even the same view, do not.
      if (event.remote || event.source !== source) current.invalidate();
    });
    document.addEventListener("visibilitychange", current.resume);
    window.addEventListener("focus", current.resume);
    return () => {
      unsubscribe(); current.dispose();
      document.removeEventListener("visibilitychange", current.resume);
      window.removeEventListener("focus", current.resume);
    };
  }, [source]);
  React.useEffect(() => { queue.current?.resume(); }, [enabled]);
  return React.useCallback(() => queue.current?.hasPending() === true, []);
}
